export const fontWeights = {
  thin: 100,
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900,
}

export const fontStyles = {
  normal: 'normal',
  italic: 'italic',
  oblique: 'oblique',
}

export const defineFont = (font) => ({
  fontFamily: `"${font.fontFamily}", ${font.fallback || 'sans-serif'}`,
  fontWeight: font?.fontWeight || fontWeights.regular,
  fontStyle: font?.fontStyle || fontStyles.normal,
})

export const declareFont = ({ name, basename, dir, fallback, formats, ...params }) => {
  const folder = dir || basename
  const path = `/fonts/${folder}/${basename}`

  const formatExt = {
    woff2: 'woff2',
    woff: 'woff',
    truetype: 'ttf',
  }

  const src = (formats || ['woff2', 'woff']).map(
    (fmt) => `url("${path}.${formatExt[fmt]}") format("${fmt}")`
  )

  return {
    ...params,
    fontDisplay: 'swap',
    src,
  }
}
